import React, { Component } from 'react'
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import NavBar from './NavBar';
import './header.css'


const backgroundStyle = {
  backgroundImage: 'url("/images/cover_2050x1155.jpeg")',

}


export default class Header extends Component {
  render() {
    return (
      <>
        <NavBar/>
        <div id='cover'
          style={backgroundStyle}
        >
        </div>
      </>
    )
  }
}
